import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getOneProject } from "../../../data/slices/project";
import {
  handelEndMonth,
  handelStartMonth,
  handleSelectedMonths,
} from "../../../data/slices/layout";
import { openModal } from "../../../data/slices/modals";
import { setMonthList } from "../../../data/slices/categories";
import { generateMonthList } from "../../../utilities/filters";
import {
  getPeriodPresetFromCurrentMonth,
  normalizeDisplayedPeriodPreset,
} from "../../../utilities/periodPresets";
import ecranAccueilIcon from "./../../../assets/img/ecran-accueil.svg";
import useAuth from "../../../hooks/useAuth";
import user from "../../../assets/img/icons/user.svg";
import { PATH_HOME } from "../../../routes/paths";
import { displayValidationErrors } from "../../../utilities/noticeDisplayer";
import { Tooltip } from "antd";

const Settings = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { project } = useSelector((state) => state.project);
  const { isSidebarClosed } = useSelector((state) => state.layout);

  const { logout } = useAuth();
  const handleLogout = async () => {
    try {
      logout();
    } catch (err) {
      console.error(err);
    }
  };

  const applyDisplayedPeriodPreset = (preset) => {
    const dates = getPeriodPresetFromCurrentMonth(
      normalizeDisplayedPeriodPreset(preset)
    );
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) return;
    dispatch(handelStartMonth(dates[0]));
    dispatch(handelEndMonth(dates[1]));
    dispatch(handleSelectedMonths());
    dispatch(setMonthList(generateMonthList(dates[0], dates[1])));
  };

  useEffect(() => {
    dispatch(getOneProject(id)).then((result) => {
      if (result.error) {
        displayValidationErrors(result?.error);
        navigate(PATH_HOME.project.root);
        return;
      }
      applyDisplayedPeriodPreset(
        result?.payload?.data?.data?.displayedPeriodPreset
      );
    });
  }, [id]);

  const openHomeScreen = () => {
    dispatch(
      openModal("project-ready-actions-modal", {
        projectId: id || project?.id,
      })
    );
  };

  return (
    <>
      <Tooltip
        placement={"top"}
        mouseLeaveDelay={0}
        mouseEnterDelay={0.8}
        trigger="hover"
        title={isSidebarClosed ? "Écran d'accueil" : null}
      >
        <button
          key={project?.id}
          type="button"
          onClick={openHomeScreen}
          className="button nav-link config-buttons"
        >
          <img className="nav-img" src={ecranAccueilIcon} alt="" />
          <span className="hidden-element">Écran d'accueil</span>
        </button>
      </Tooltip>
      <Tooltip
        placement={"top"}
        trigger="hover"
        title={isSidebarClosed ? "Déconnecter" : null}
        mouseLeaveDelay={0}
        mouseEnterDelay={0.8}
      >
        <button
          key="logout"
          type="button"
          onClick={handleLogout}
          className="button nav-link config-buttons"
        >
          <img className="nav-img" src={user} />
          <span className="hidden-element log-out-element ">Déconnecter</span>
        </button>
      </Tooltip>
    </>
  );
};

export default Settings;
